import infoService from '../../services/info';
import axios from 'axios';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  state: {
    loggedInUser: null,
    settings: {}
  },

  getters: {
    loggedInUser: state => state.loggedInUser,
    settings: state => state.settings,
    isLoggedIn: state => {
      return state.loggedInUser && !state.loggedInUser.internalOnly && state.loggedInUser.emails.value;
    },
    canAccess: state => allowKey => {
        return state.loggedInUser && !state.loggedInUser.internalOnly && state.loggedInUser.emails.value
        &&
        (
          (state.settings[allowKey] && state.settings[allowKey].split(',').includes(state.loggedInUser.emails.value.split('@')[0]))
          ||
          (state.settings['it-staff'] && state.settings['it-staff'].split(',').includes(state.loggedInUser.emails.value.split('@')[0]))
        );
    }
  },

  mutations: {
    SET_LOGGED_IN_USER(state, value) {
      state.loggedInUser = value;
    },
    CLEAR_LOGGED_IN_USER(state, value) {
      state.loggedInUser = null;
    },
    SET_SETTINGS(state, value) {
      state.settings = value;
    },
  },

  actions: {
    getLoggedInUser: ({ commit }) => {
      axios.get(`${BASE_API}/auth`, {withCredentials: true}).then((r) => { commit('SET_LOGGED_IN_USER', r.data) });
    },
    getSettings: ( { commit } ) => {
      axios.get(`${BASE_API}/settings/`).then( r => {
        let data = {};
        r.data.forEach( e => {
          data[e['setting']] = e['data'];
        });
        commit('SET_SETTINGS', data)
      } ).catch(e => {
        commit('SET_SETTINGS', {})
      })
    },
  },
};



// WEBPACK FOOTER //
// /src/store/modules/info.js